import { render, staticRenderFns } from "./SendTransitRequest.vue?vue&type=template&id=3caf528c"
import script from "./SendTransitRequest.vue?vue&type=script&lang=ts"
export * from "./SendTransitRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports